import React from "react";
import { useMatch, useNavigate } from "react-router";
import { PROFILE_ROUTE, USER_SETTINGS_ROUTE } from "Constants";
import { useLoginInfo, useRedirect } from "Hooks";
import UserSettingsLayout from "./UserSettingsLayout";

const UserSettings = () => {
  const { isSSOLogin, hasLoaded } = useLoginInfo();

  const shouldRedirect = useMatch({
    path: `${USER_SETTINGS_ROUTE}`,
  });

  useRedirect({
    to: PROFILE_ROUTE,
    when: Boolean(shouldRedirect),
  });

  const navigate = useNavigate();
  const matchRouteParams = useMatch({
    path: `${USER_SETTINGS_ROUTE}/*`,
  });

  const selectedNavNode = matchRouteParams
    ? Object.values(matchRouteParams.params)[0]
    : "";

  const handleNavigate = (selected: string) => {
    navigate(selected);
  };

  return (
    <UserSettingsLayout
      isSSOLogin={isSSOLogin && hasLoaded}
      handleNavigate={handleNavigate}
      selected={selectedNavNode ?? ""}
    />
  );
};

export default UserSettings;
